<template>
  <el-container class="height100">
    <el-header class="obpm-header-t" ref="top1" v-if="isAdmin">
      <admin_header />
    </el-header>

    <el-main ref="tabCon" class="domainMain">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="obpm-header-nav" ref="top2" v-if="isCanExit&&isAdmin">
        <el-breadcrumb-item :to="{ path: '/home' }">{{$t('location')}}</el-breadcrumb-item>

        <el-breadcrumb-item :to="{ path: '/main' }">{{$t('enterprise_list')}}</el-breadcrumb-item>
        <el-breadcrumb-item>{{$t('detail')}}</el-breadcrumb-item>
      </el-breadcrumb>

       <el-breadcrumb separator-class="el-icon-arrow-right" class="obpm-header-nav" ref="top2" v-if="!isCanExit&&isAdmin">
        <el-breadcrumb-item>{{$t('location')}}</el-breadcrumb-item>

        <el-breadcrumb-item>{{$t('enterprise_list')}}</el-breadcrumb-item>
        <el-breadcrumb-item>{{$t('detail')}}</el-breadcrumb-item>
      </el-breadcrumb>

      <el-tabs class="domain domainCon" v-model="activeName" type="card" @tab-click="handleClick" ref="tabMain">
        <el-tab-pane :label="$t('baseInfo')" name="BasicInfo" class="baseinfo" v-if="!isDeparmentAdminRole">
          <baseinfo ref='baseinfo' v-if="isShow.isBaseinfo"/>
        </el-tab-pane>
        <el-tab-pane :label="$t('department')" name="Dept" class="department" >
          <department  v-if="isShow.isDept" :key="DeptTimer"/>
        </el-tab-pane>
        <!-- <el-tab-pane label="组织关系" name="orgRelation" class="orgRelation" v-if="!isDeparmentAdminRole">
          <orgRelation ref='baseinfo' v-if="isShow.isorgRelation"/>
        </el-tab-pane> -->
        <el-tab-pane :label="$t('user')" name="User" class="user" :key="UserTimer">
          <user  v-if="isShow.isUser"/>
        </el-tab-pane>
        <el-tab-pane label="应用" name="Apps" class="appconfig"  v-if="!isDeparmentAdminRole">
          <appconfig  v-if="isShow.isApp"/>
        </el-tab-pane>
        <!-- <el-tab-pane :label="$t('weixinConfig')" name="WeixinConfig" class="weixin" v-if="(isOpen&&isAdmin&&!isAdminDept) || (isOpen&&!isAdmin&&!isSecret&&!isExamine)  || !isOpen">
          <weixin  v-if="isShow.isWeixin"/>
        </el-tab-pane>
        <el-tab-pane :label="$t('dingdingConfig')" name="DingDingConfig" class="dingding" v-if="(isOpen&&isAdmin&&!isAdminDept) || (isOpen&&!isAdmin&&!isSecret&&!isExamine) || !isOpen">
          <dingding  v-if="isShow.isDingDing"/>
        </el-tab-pane> -->
        <el-tab-pane label="组织管理员" name="Adns" class="manager" v-if="!isDeparmentAdminRole">
          <manager  v-if="isShow.isManager"/>
        </el-tab-pane>
         <el-tab-pane label="部门管理员" name="DepartAdn" class="manager">
          <departmentmanager  v-if="isShow.isDepartManager"/>
        </el-tab-pane>
        <el-tab-pane label="企业钱包" name="CompWallet" class="manager" v-if="showCompWalletflag">
          <CompWallet  v-if="isShow.CompWallet"/>
        </el-tab-pane>
        <!-- <el-tab-pane :label="$t('calendar')" name="WkCld" class="calendar" v-if="(isOpen&&isAdmin&&!isAdminDept) || (isOpen&&!isAdmin&&!isSecret&&!isExamine)  || !isOpen">
          <calendar  v-if="isShow.isCalendar"/>
        </el-tab-pane>
        <el-tab-pane :label="$t('fieldextend')" name="UserFormExtends" class="fieldextend" v-if="(isOpen&&isAdmin&&!isAdminDept) || (isOpen&&!isAdmin&&!isSecret&&!isExamine)  || !isOpen">
          <fieldextend  v-if="isShow.isFieldextend" :key="fieldTimer"/>
        </el-tab-pane> -->
        <el-tab-pane :label="$t('userlog')" name="Log" class="userlog" v-if="isSuper">
          <userlog  v-if="isShow.isUserlog"/>
        </el-tab-pane>
        <el-tab-pane :label="$t('flowstaterts')" name="FlowIntervention" class="flowstaterts" v-if="!isDeparmentAdminRole">
          <flowstaterts  v-if="isShow.isFlowstaters"/>
        </el-tab-pane>
        <el-tab-pane label="定时任务" name="TimedTask" class="flowstaterts" v-if="isSuper">
          <timedtask  v-if="isShow.isTimedTask"/>
        </el-tab-pane>
        <!-- <el-tab-pane :label="$t('emailconfig')" name="Email" class="emailconfig" v-if="(isOpen&&isAdmin&&!isAdminDept) || (isOpen&&!isAdmin&&!isSecret&&!isExamine)  || !isOpen">
          <emailconfig  v-if="isShow.isEmailconfig"/>
        </el-tab-pane> -->
      </el-tabs>
    </el-main>
  </el-container>
</template>

<script>
import admin_header from "@/components/admin_header.vue";
import baseinfo from "@/components/baseinfo.vue";//基本信息
import department from "@/components/department.vue";
import user from "@/components/user.vue";
import appconfig from "@/components/appconfig.vue";
import weixin from "@/components/weixin.vue";
import dingding from "@/components/dingding.vue";
import manager from "@/components/manager.vue";
import departmentmanager from "@/components/departmentmanager.vue";
import calendar from "@/components/calendar.vue";
import fieldextend from "@/components/fieldextend.vue";
import userlog from "@/components/userlog.vue";
import flowstaterts from "@/components/flowstaterts.vue";
import emailconfig from "@/components/emailconfig.vue";
import timedtask from "@/components/timedtask.vue";
import CompWallet from "@/components/CompWallet.vue";//企业钱包
import orgRelation from "@/components/orgRelation.vue";//组织关系
export default {
  components: {
    admin_header,
    baseinfo,
    department,
    user,
    appconfig,
    weixin,
    dingding,
    manager,
    departmentmanager,
    calendar,
    fieldextend,
    userlog,
    flowstaterts,
    emailconfig,
    timedtask,
    CompWallet,
    orgRelation
  },

  created() {
    this.isSuper = this.$store.state.currentUser.type=="super"?true:false;

    if(this.$store.state.currentUser.isOpenSecurity) {
      
      this.isOpen=true;
      if (this.$store.state.currentUser.type == 'admin') {
        this.isAdmin = true;//是否是系统管理员
        if (this.$store.state.currentUser.departments.length > 0 && this.$store.state.currentUser.domains.length > 0) {
          //部门及的系统管理员
          this.isAdminDept = true;
          this.activeName='Dept';
          this.isShow.isBaseinfo=false;
          this.isShow.isDept=true;

        }

      }else if(this.$store.state.currentUser.type == 'secret'){
        this.isSecret = true;//是否是安全保密员
        this.activeName='User';
        this.isShow.isBaseinfo=false;
        this.isShow.isUser=true;
      }
      else if(this.$store.state.currentUser.type == "examine"){
        this.isExamine = true;//是否是安全审计员
        this.activeName='Log';
        this.isShow.isBaseinfo=false;
        this.isShow.isUserlog=true;
      }
    }else{
      this.isOpen=false;
    }
    if(window.location.href.split("&")[1]){
      if(window.location.href.split("&")[1].indexOf("obpm")!=-1){
        this.isCanExit=false;
      }
    }

     

      if(location.host.indexOf("v5qy.test.baibaodun.cn")>-1||location.host.indexOf("v5qy")>-1||location.host.indexOf("192")>-1||location.host.indexOf("baibaodun")>-1){//只有测试跟正式环境才显示企业钱包
         this.showCompWalletflag=true
      }
    
  },
  mounted(){
     this.$api.qeuryUserAdminRole(this.$route.query.domainid,{//查询用户权限
        onSucess:response=>{
            console.log(response)
            if(response.data){
              this.$nextTick(()=>{
                console.log(response.data.data.isDeparmentAdminRole)
                this.isDeparmentAdminRole=response.data.data.isDeparmentAdminRole
                localStorage.setItem("isDeparmentAdminRole",this.isDeparmentAdminRole)
                if(this.isDeparmentAdminRole){
                  this.isShow.isDept=true
                  this.activeName="Dept"
                }
             }) 
            }
        }
      })  
  },
  data() {
    return {
      isDeparmentAdminRole:false,//false代表不是部门管理员，是组织管理员
      activeName: "BasicInfo",
      isShow:{
        isBaseinfo:true,
        isDept:false,
        isUser:false,
        isApp:false,
        isWeixin:false,
        isDingDing:false,
        isManager:false,
        isDepartManager:false,
        isCalendar:false,
        isFieldextend:false,
        isUserlog:false,
        isFlowstaters:false,
        isTimedTask:false,
        isEmailconfig:false,
        isorgRelation:false,
      },
      isCanExit:true,
      DeptTimer:'',
      UserTimer:'',
      fieldTimer:'',
      height:0,
      isOpen:false,//开关是否开启
      isAdmin:false,//是否是系统管理员
      isAdminDept:false,//标识是否是部门及的系统管理员
      isSecret:false,//是否是安全保密员
      isExamine:false,//是否是安全审计员
      isSuper:false,
      showCompWalletflag:false,//显示企业钱包
    };
  },

  methods: {
    resetisShow(){
      for(let i in this.isShow){
        this.isShow[i]=false;
      }
    },
    handleClick(tab) {
      switch(tab.name){
        case "BasicInfo":
          this.resetisShow();
          this.isShow.isBaseinfo=true;
          break;
        case "Dept":
          this.resetisShow();
          this.isShow.isDept=true;
          this.DeptTimer=new Date().getTime();
          break;
        case "orgRelation":
        this.resetisShow();
        this.isShow.isorgRelation=true;
        break;
        case "User":
          this.resetisShow();
          this.isShow.isUser=true;
          this.UserTimer=new Date().getTime();
          break;
        case "Apps":
          this.resetisShow();
          this.isShow.isApp=true;
          break;
        case "WeixinConfig":
          this.resetisShow();
          this.isShow.isWeixin=true;
          break;
        case "DingDingConfig":
          this.resetisShow();
          this.isShow.isDingDing=true;
          break;
        case "Adns":
          this.resetisShow();
          this.isShow.isManager=true;
          break;
        case "DepartAdn":
          this.resetisShow();
          this.isShow.isDepartManager=true;
          break; 
        case "CompWallet":
          this.resetisShow();
          this.isShow.CompWallet=true;
          break;    
        case "WkCld":
          this.resetisShow();
          this.isShow.isCalendar=true;
          break;
        case "UserFormExtends":
          this.resetisShow();
          this.isShow.isFieldextend=true;
          this.fieldTimer=new Date().getTime();
          break;
        case "Log":
          this.resetisShow();
          this.isShow.isUserlog=true;
          break;
        case "FlowIntervention":
          this.resetisShow();
          this.isShow.isFlowstaters=true;
          break;
        case "TimedTask":
          this.resetisShow();
          this.isShow.isTimedTask=true;
          break;  
        case "Email":
          this.resetisShow();
          this.isShow.isEmailconfig=true;
          break;
          
      }
    }
  }
};
</script>

<style lang="scss">

</style>